import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Avatar } from 'avatar-components/Avatar';
import styled from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';

/* @bend-expect trellis-tokenized */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUserDisplay = styled.span.withConfig({
  displayName: "SourceUserAndAvatar__StyledUserDisplay",
  componentId: "sc-100eqwu-0"
})(["font-weight:", ";height:18px;line-height:", ";"], ({
  theme
}) => theme.typography['heading-400'].fontWeight, ({
  theme
}) => theme.typography['heading-25'].lineHeight);

/* @bend-expect trellis-tokenized */
const Span = styled.span.withConfig({
  displayName: "SourceUserAndAvatar__Span",
  componentId: "sc-100eqwu-1"
})(["display:", ";align-items:center;height:18px;color:", ";"], ({
  isInline
}) => isInline ? 'inline-flex' : 'flex', ({
  isFaded,
  theme
}) => isFaded ? theme.color['text-core-disabled'] : theme.color['text-core-subtle']);

/* @bend-expect trellis-tokenized */
const Div = styled.div.withConfig({
  displayName: "SourceUserAndAvatar__Div",
  componentId: "sc-100eqwu-2"
})(["display:", ";align-items:center;height:18px;color:", ";"], ({
  isInline
}) => isInline ? 'inline-flex' : 'flex', ({
  isFaded,
  theme
}) => isFaded ? theme.color['text-core-disabled'] : theme.color['text-core-subtle']);
const SourceUserAndAvatar = ({
  user,
  isInline
}) => {
  var _user$email;
  const Container = isInline ? Span : Div;
  return /*#__PURE__*/_jsx(Tooltip, {
    "data-test-id": "source-interpretation-user-tooltip",
    disabled: !user.email,
    title: user.email,
    children: /*#__PURE__*/_jsxs(Container, {
      isInline: isInline,
      "data-test-id": "source-interpretation-user-and-avatar",
      isFaded: user.gdprDeleted || user.simplyRemoved || user.deactivated,
      children: [/*#__PURE__*/_jsx(Flex, {
        marginInline: "100",
        alignItems: "center",
        children: /*#__PURE__*/_jsx(Avatar, {
          type: user.email ? 'hubSpotUserEmail' : 'contact',
          hubSpotUserEmail: (_user$email = user.email) !== null && _user$email !== void 0 ? _user$email : undefined,
          size: "xxs"
        })
      }), /*#__PURE__*/_jsx(StyledUserDisplay, {
        children: /*#__PURE__*/_jsx(TruncateString, {
          tooltip: false,
          matchContentWidth: true,
          children: user.displayResult
        })
      })]
    })
  });
};
export default SourceUserAndAvatar;